import { getSeedingMeProposal as getSeedingMeProposalApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  GetSeedingMeProposalServiceRequest,
  GetSeedingMeProposalServiceResponse,
} from './get-seeding-me-proposal.dto';
import {
  GetSeedingMeProposalServiceRequestSchema,
  GetSeedingMeProposalServiceResponseSchema,
} from './get-seeding-me-proposal.dto';

export const getSeedingMeProposalService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetSeedingMeProposalServiceRequestSchema),
    async (
      request: GetSeedingMeProposalServiceRequest,
    ): Promise<GetSeedingMeProposalServiceResponse> => {
      const apiResponse = await getSeedingMeProposalApi(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '제안 받은 캠페인 목록 조회에 실패했습니다.');
      }

      // BE 표준 wrapper 의 link.next(다음 페이지 URL, 없으면 null)가 다음 페이지 유무를 알려줌.
      // pageParam 은 page 번호라 nextPage 는 page+1 로 환산한다 (get-recruitment-campaigns 등 도메인 표준 패턴).
      const page = request.page ?? 1;
      const hasNext = apiResponse.link?.next != null;
      const total = apiResponse.link?.total ?? apiResponse.data.list.length;
      return {
        list: apiResponse.data.list,
        pagination: {
          hasNext,
          nextPage: hasNext ? page + 1 : null,
          total,
        },
      };
    },
    validateServiceResponse(GetSeedingMeProposalServiceResponseSchema),
  ),
);
